import { useEffect } from "react";
import { pages } from "@microsoft/teams-js";
import classNames from "./RemoveTab.module.css";
import { useRoomId } from "../context/room/room";
import { useAxios } from "../../hooks/axios";
import api from "../../hooks/api";

export default function RemoveTab() {
  const roomId = useRoomId();

  const axios = useAxios();
  const removeBot = api.useRemoveBot(axios);

  useEffect(() => {
    const onRemoveHandler = async (event: pages.config.RemoveEvent) => {
      await removeBot({ roomId: roomId });
      event.notifySuccess();
    };
    pages.config.registerOnRemoveHandler(onRemoveHandler);
    pages.config.setValidityState(true);
  }, [removeBot, roomId]);

  return (
    <div className={classNames.RemoveTab}>
      <h2>Remove Langfinity About You're about to remove your tab...</h2>
      <p>
        Are you sure you want to remove this tab? You'll lose access to
        real-time translation for your meetings. You can always add the
        Langfinity translation tab again later if needed.
      </p>
    </div>
  );
}
